export default function BrandMark() {
  return (
    <span className="brand-mark" aria-hidden="true">
      <svg viewBox="0 0 40 40" role="img">
        <circle cx="20" cy="20" r="8" fill="currentColor" />
        <ellipse cx="20" cy="20" rx="17" ry="8" fill="none" stroke="currentColor" strokeWidth="2.2" transform="rotate(-28 20 20)" />
        <ellipse cx="20" cy="20" rx="15" ry="6" fill="none" stroke="currentColor" strokeWidth="1.6" opacity=".52" transform="rotate(24 20 20)" />
        <circle cx="34" cy="13" r="2.6" fill="#06b6d4" />
      </svg>
    </span>
  )
}
